import { render, staticRenderFns } from "./augmentation_capital_update.vue?vue&type=template&id=d5157efa&"
import script from "./augmentation_capital_update.vue?vue&type=script&lang=js&"
export * from "./augmentation_capital_update.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports